import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Switch } from './ui/switch';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const formatApiError = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg || JSON.stringify(e)).join(', ');
  if (typeof detail === 'object' && detail !== null) return detail.msg || JSON.stringify(detail);
  return error.message || 'Error desconocido';
};

export function StateDialog({ open, onClose, state }) {
  const [formData, setFormData] = useState(
    state || {
      name: '',
      color: '#2B4C3B',
      order: 1,
      blocks_schedule: false,
      requires_payment: false,
    }
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (state) {
        await axios.put(`${API_URL}/api/states/${state.id}`, formData, {
          withCredentials: true,
        });
      } else {
        await axios.post(`${API_URL}/api/states`, formData, {
          withCredentials: true,
        });
      }
      onClose();
    } catch (error) {
      setError(formatApiError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#FFFFFF] border-[#E8E5DD]">
        <DialogHeader>
          <DialogTitle className="text-2xl text-[#1A1C18]">
            {state ? 'Editar Estado' : 'Nuevo Estado'}
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name">Nombre</Label>
            <Input
              id="name"
              data-testid="state-name-input"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="mt-1 bg-transparent border-[#E8E5DD]"
            />
          </div>

          <div>
            <Label htmlFor="color">Color</Label>
            <div className="flex gap-2 mt-1">
              <Input
                id="color"
                type="color"
                data-testid="state-color-input"
                value={formData.color}
                onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                className="w-20 h-10"
              />
              <Input
                type="text"
                value={formData.color}
                onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                className="flex-1 bg-transparent border-[#E8E5DD]"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="order">Orden</Label>
            <Input
              id="order"
              type="number"
              data-testid="state-order-input"
              value={formData.order}
              onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
              required
              className="mt-1 bg-transparent border-[#E8E5DD]"
            />
          </div>

          <div className="flex items-center justify-between p-3 rounded-lg border border-[#E8E5DD]">
            <Label htmlFor="blocks_schedule" className="cursor-pointer">
              Bloquea agenda
            </Label>
            <Switch
              id="blocks_schedule"
              data-testid="state-blocks-schedule-switch"
              checked={formData.blocks_schedule}
              onCheckedChange={(checked) =>
                setFormData({ ...formData, blocks_schedule: checked })
              }
            />
          </div>

          <div className="flex items-center justify-between p-3 rounded-lg border border-[#E8E5DD]">
            <Label htmlFor="requires_payment" className="cursor-pointer">
              Requiere confirmación de pago
            </Label>
            <Switch
              id="requires_payment"
              data-testid="state-requires-payment-switch"
              checked={formData.requires_payment}
              onCheckedChange={(checked) =>
                setFormData({ ...formData, requires_payment: checked })
              }
            />
          </div>

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-800">{error}</p>
            </div>
          )}

          <div className="flex gap-3 justify-end">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button
              type="submit"
              data-testid="submit-state-button"
              disabled={loading}
              className="bg-[#2B4C3B] hover:bg-[#3A604D] text-white"
            >
              {loading ? 'Guardando...' : state ? 'Actualizar' : 'Crear Estado'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}